import ModalPortal from '@/components/ModalPortal/ModalPortal';
import { ButtonAlign } from '@/uikit/components/Button/consts';
import ButtonLink from '@/uikit/components/ButtonLink/ButtonLink';
import { ClickableAction } from '@/uikit/components/Clickable/consts';
import { ContactTelephoneAlign } from '@/uikit/components/ContactTelephone/consts';
import ContactTelephone from '@/uikit/components/ContactTelephone/ContactTelephone';
import { HeadlineColor } from '@/uikit/components/Headline/consts';
import Headline from '@/uikit/components/Headline/Headline';
import ModalContent from '@/uikit/components/Modal/ModalContent';
import type { PressOnCallButtonProps } from './types';

const PressOnCallButton = ({
  children = 'Rufbereitschaft kontaktieren',
  modalID = 'on-call-service',
}: PressOnCallButtonProps) => {
  return (
    <>
      <ButtonLink
        align={ButtonAlign.Left}
        actionType={ClickableAction.Modal}
        modallink={modalID}
      >
        {children}
      </ButtonLink>
      <ModalPortal id={modalID}>
        <ModalContent withSpaceBetweenChildren>
          <Headline headlineColor={HeadlineColor.Dark}>
            Unser Service für Journalist:innen: die Presse-Rufbereitschaft.
          </Headline>
          <ContactTelephone
            phone="0162.6276374"
            description="Außerhalb der Kernzeiten erreichen Sie uns ausschließlich für ereignisbezogene und dringende Presseanfragen von 19:00 bis 8:00 Uhr."
            alignment={ContactTelephoneAlign.Center}
          />
        </ModalContent>
      </ModalPortal>
    </>
  );
};

export default PressOnCallButton;
